define('collections/calendar/session/exercise/weight/sets',[
    'underscore',
    'backbone',
    'utils',
    // Pull in the Model module from above
    'models/calendar/session/exercise/weight/set'
], function(
    // libs
    _, Backbone, U,
    // model
    MWeightSet
) {

    var CWeightSets = Backbone.Collection.extend({
        model: MWeightSet,

        pushSet: function(count, options) {
            var models = [],
                firstSet = this.first();

            while (count-- > 0) { // while count down to zero
                models.push(new MWeightSet(firstSet ? firstSet.toJSON() : null)); // new sets are initialized with first set attributes
            }

            return this.push(models, options);
        },

        popSet: function(count, options) {
            var models = this.rest(this.length - count);
            return this.remove(models, options);
        },

        ////////////
        // events //
        ////////////
        onNumSetsChange: function(value) {
            var changes = value - this.length;
            if (changes < 0) {
                this.popSet(Math.abs(changes));
            } else if (changes > 0) {
                this.pushSet(changes);
            }
        },

    });

    return CWeightSets;
});

